import Vue from "vue";
import i18n from "./i18n";
import App from "./App.vue";
import store from "./store";
import "./assets/css/setting.scss";
import "./assets/css/reset.scss";
import "./assets/css/common.scss";
import "./assets/css/anim.scss";
import "./assets/icons"; //svg图标
import "./assets/js/rem";
import "./assets/fonts/font.css";
import Axios from "./http/index";
import loadConfig from "@web3Config/config";
import router from "./router";
import Toasted from "vue-toasted";
import directive from "./directive";
import formatter from "./utils/formatter";
import bigNumber from "bignumber.js";
import WebApp from "@twa-dev/sdk";
import { anim } from "./mixins/anim.js";
import { WOW } from "wowjs";
// import vconsole from "vconsole"
// new vconsole()
import "animate.css";
import { EventBus } from "@assets/js/eventBus";
import pop from "./assets/js/pop";

import web3Wallet from "@web3Wallet/index";

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

window._v = Vue.prototype;
_v.web3Wallet = web3Wallet;
_v.screenWidth = window.innerWidth;
_v.screenHeight = window.innerHeight;
WebApp.ready();
WebApp.expand();
WebApp.isVerticalSwipesEnabled = false;
WebApp.isClosingConfirmationEnabled = true;

Axios.install(Vue);
_v.EventBus = EventBus;

const options = {
  duration: 3000,
  position: "top-center",
  fullWidth: false,
};
Vue.use(Toasted, options);

_v.WebApp = WebApp;
for (let key in pop) {
  _v[key] = pop[key];
}

for (let key in loadConfig) {
  _v[key] = loadConfig[key];
}
for (let func in formatter) {
  _v[func] = formatter[func];
}
for (let func in formatter) {
  _v[func] = formatter[func];
}

Vue.use(directive);
for (let func in formatter) {
  Vue.filter(func, formatter[func]);
}
_v.formatter = formatter;
_v.bigNumber = function (num) {
  if (!num) {
    return bigNumber(0)
  };
  const str = num.toString();
  // 检查是否是科学计数法表示
  if (/e/i.test(str)) {
    return bigNumber(Number(num.toFixed(18).replace(/0+$/, ""))); // 保留18位精度
  }
  return bigNumber(str);
};

Vue.config.productionTip = false;

_v.registerBodyClick = (isRegister, callback) => {
  isRegister ? document.body.addEventListener("click", callback) : document.body.removeEventListener("click", callback);
};

Vue.mixin(anim);

_v.tokenBalanceTimer = null
_v.kLinePullTimer = null

_v.$wow = WOW;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
